'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var bumbag = require('bumbag');
var _get = require('lodash/get');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ErrorListItem = bumbag.styled(bumbag.List.Item)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  padding-left: 0.5rem;\n\n  ::before {\n    content: '-';\n    margin-left: -0.5rem;\n    margin-right: 0.25rem;\n  }\n"])));

var ErrorMessage = function ErrorMessage(_ref) {
  var _ref$description = _ref.description,
      description = _ref$description === void 0 ? 'An error occured.' : _ref$description,
      err = _ref.err;
  var errors = err;

  if (_get__default["default"](err, 'data.errors.length', 0) > 0 && typeof _get__default["default"](err, 'data.errors[0]') !== 'object') {
    errors = _objectSpread({}, err, {
      // @ts-expect-error TS(7006): Parameter 'err' implicitly has an 'any' type.
      data: _objectSpread({}, _get__default["default"](err, 'data'), {
        errors: _get__default["default"](err, 'data.errors').map(function (err) {
          return {
            message: err
          };
        })
      })
    });
  }

  return /*#__PURE__*/React__default["default"].createElement(bumbag.Box, null, /*#__PURE__*/React__default["default"].createElement(bumbag.Paragraph, {
    marginTop: "major-2"
  }, description), errors && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, _get__default["default"](errors, 'data.errors.length', 0) > 0 && /*#__PURE__*/React__default["default"].createElement(bumbag.List, {
    marginTop: "major-1"
  }, _get__default["default"](errors, 'data.errors', []).map(function (error, i) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React__default["default"].createElement(ErrorListItem, {
        key: i
      }, error.message || error.code)
    );
  })), _get__default["default"](errors, 'data.message', errors.message) && /*#__PURE__*/React__default["default"].createElement(bumbag.Paragraph, {
    marginTop: "major-2"
  }, /*#__PURE__*/React__default["default"].createElement(bumbag.Text, {
    fontWeight: "semibold"
  }, "Details"), ":", /*#__PURE__*/React__default["default"].createElement("br", null), _get__default["default"](errors, 'data.message', errors.message))));
};

ErrorMessage.defaultProps = {
  description: 'An error occured',
  err: null
};

exports["default"] = ErrorMessage;
